import React from 'react'
import { Navigate } from 'react-router-dom';

const SimulatorRedirect = () => {
    return (
        <Navigate to={'/optimizer'} replace={true} />
    );
}

export default SimulatorRedirect